import React, { Component } from 'react'
import Modal from "react-bootstrap/Modal";

class Menus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }
    componentDidMount() {
        this.checkSession();
    }

    handleClose() {
        this.setState({ show: false, effect: 'zoomOut' });
    }

    handleShow() {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    setCookie(c_name, value, exdays) {
        var exdate = new Date(); exdate.setDate(exdate.getDate() + exdays); var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString()); document.cookie = c_name + "=" + c_value;
    }

    getCookie(c_name) {
        var c_value = document.cookie; var c_start = c_value.indexOf(" " + c_name + "="); if (c_start == -1) { c_start = c_value.indexOf(c_name + "="); } if (c_start == -1) { c_value = null; } else { c_start = c_value.indexOf("=", c_start) + 1; var c_end = c_value.indexOf(";", c_start); if (c_end == -1) { c_end = c_value.length; } c_value = unescape(c_value.substring(c_start, c_end)); } return c_value;
    }

    checkSession() {
        var c = this.getCookie("visited");
        if (c === "yes") {
            //   alert("Welcome back!");
            this.handleClose();
        } else {
            this.setCookie("visited", "yes", 365);
            //   alert("Welcome new visitor!");
            // this.handleShow();
        }
    }


    render() {
        return (
            <>
                <span onClick={this.handleShow} className={"btn btn-sm bg-cs2 cpt"} style={{ color: '#fff', padding: '0' }}>
                    <i className={'mdi mdi-information mr-1'} />
                    How To Play
                </span>
                <Modal
                    size="md"
                    backdrop="static"
                    centered={true}
                    show={this.state.show}
                    onHide={this.handleClose}
                    aria-labelledby="help-md-modal"
                    className={"animated " + this.state.effect}
                >
                    <Modal.Header className="Header">
                        How To Play
                        <button type="button" className="close p-2" onClick={this.handleClose}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-helper">
                        <p className={'font-light text-b2'}>
                            <i class="mdi mdi-arrow-right mr-1"></i> Enter your <span className="text-success">BET AMOUNT</span> and <span className="text-success">CASHOUT</span> value, Then click<span className="text-warning"> PLACE BET</span>.
                            Yow will be automatically added to the Next Round of the Game.
                        </p>
                        <p className={'font-light text-b2'}>
                            <i class="mdi mdi-arrow-right mr-1"></i> Once the graph curve starts increasing, You can either click on <span className="text-success">CASHOUT</span> to cash out Manually or wait for your Cashout Value.
                        </p>

                        <p className={'font-light text-b2'}>
                            <i class="mdi mdi-arrow-right mr-1"></i>  If the graph busts before you cash out or reach Your cashout value, you lose.
                        </p>

                        <h4 className="text-white">
                            Keywords
                        </h4>
                        <p className={'font-light text-b2'}>

                            <code>AMOUNT</code> <span>- Bet amount in kshs you wish to stake With (Minimum Kshs10)</span>
                            <br />
                            <code>CASHOUT</code> <span>- Point where the system should Cash you out automatically</span>
                            <br />
                            <code>POSSIBLE WIN</code> <span>- The total amount to Win i.e bet amount x cashout</span>

                        </p>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default Menus;